/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as LandFindingPageLoader } from './LandFindingPage/LandFindingPage.duck';
import { loadData as AdminDreamListingReviewPageLoader } from './AdminDreamListingReviewPage/AdminDreamListingReviewPage.duck';
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as CustomerCostEstimationToolPageLoader } from './CustomerCostEstimationToolPage/CustomerCostEstimationToolPage.duck';
import { loadData as ContactSupplierPageLoader } from './ContactSupplierPage/ContactSupplierPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as CostEstimationDetailsPageLoader } from './CostEstimationDetailsPage/CostEstimationDetailsPage.duck';
import { loadData as DreamHomePageLoader } from './DreamHomePage/DreamHomePage.duck';
import { loadData as DocumentManagementPageLoader } from './DocumentManagementPage/DocumentManagementPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as PropertyDeveloperPageLoader } from './PropertyDeveloperPage/PropertyDeveloperPage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as SupplierCostEstimationToolPageLoader } from './SupplierCostEstimationToolPage/SupplierCostEstimationToolPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    LandFindingPage: {
      loadData: LandFindingPageLoader,
    },
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    AdminDreamListingReviewPage: {
      loadData: AdminDreamListingReviewPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactSupplierPage: {
      loadData: ContactSupplierPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    CostEstimationDetailsPage: {
      loadData: CostEstimationDetailsPageLoader,
    },
    CustomerCostEstimationToolPage: {
      loadData: CustomerCostEstimationToolPageLoader,
    },
    DreamHomePage: {
      loadData: DreamHomePageLoader,
    },
    DocumentManagementPage: {
      loadData: DocumentManagementPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    PropertyDeveloperPage: {
      loadData: PropertyDeveloperPageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    SupplierCostEstimationToolPage: {
      loadData: SupplierCostEstimationToolPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
  };
};

export default getPageDataLoadingAPI;
